export const _LOAD_MODEL_ = 'Load:Manager';
export const _DELETE_MANAGER_ = 'Delete:Manager';

export const MODEL = {
  id: null,
  name: '',
  email: '',
  supervisors_count: null,
};
